import { Component, ViewEncapsulation } from '@angular/core';
import { config } from '../../../../config/config';
import { EventTimeService } from '../../../services/event.time.service';
import { ExportService } from '../../../services/export.csv.service';
import { HubApiService } from '../../../services/hub.api.service';
import {
  CustomDefaultPlaceCategoryStore,
  EditorChoiceStore,
  HubExportPdfStore,
} from '../../../stores/hub.calendar.store';
import { ExportPdfModalActions, ExportPdfModalData } from './export.pdf.modal.provider';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { EditorChoiceDataSource } from '../../../models/hub/hub.event';
import { LocalStorageService } from '../../../services/localStorageService';
import { CustomDefaultPlaceCategory } from '../../../commands/pagination.query.command';
import { PlaceType } from '../place.category/customize.place.category.component';
import { isEmptyObject } from '../../../common/extensions';

@Component({
  templateUrl: './export.pdf.modal.component.html',
  styleUrls: ['./export.pdf.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExportPdfModalComponent extends BaseComponent {
  public data: ExportPdfModalData;
  public hubName: string;
  public progress: string;
  public editorChoice: EditorChoiceDataSource;
  public customDefaultPlaceCategory: any;

  constructor(
    private dialogRef: MatDialogRef<ExportPdfModalComponent>,
    private actions: ExportPdfModalActions,
    private hubApiService: HubApiService,
    private exportService: ExportService,
    private exportPdfStore: HubExportPdfStore,
    private editorChoiceStore: EditorChoiceStore,
    private customDefaultPlaceCategoryStore: CustomDefaultPlaceCategoryStore,
    data: ExportPdfModalData
  ) {
    super();

    this.data = Object.assign(
      {
        isEvent: true,
        category: 'All',
        eventSource: 'All',
        placeSource: 'All',
        isApproved: true,
        isPrintVersion: false,
        page: 1,
        limit: config.searchLimit,
        exportType: 'PDF',
        approvalStatus: 'all'
      },
      data
    );

    this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe((editorChoice: EditorChoiceDataSource) => {
      console.log('editorChoice in pdf', editorChoice);
      this.editorChoice = editorChoice;
    });

    this.loadCustomCategories();
  }

  public loadCustomCategories() {
    setTimeout(() => {
      this.customDefaultPlaceCategory = LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage();
      this.customDefaultPlaceCategory.toggle = {
        toggle: this.customDefaultPlaceCategory.toggle,
        dataSource: {
          businessType: this.customDefaultPlaceCategory.businessType,
        },
      };

      this.customDefaultPlaceCategoryStore.CustomDefaultPlaceCategoryCommand.takeUntil(this.isDestroyed).subscribe(
        (category: CustomDefaultPlaceCategory) => {
          if (!isEmptyObject(category)) {
            console.log('receive from', category);
            if (category.useDefault) {
              this.customDefaultPlaceCategory.useDefault = true;
            }
          }
        }
      );
    }, 2000);
  }

  public selectCustomDefaultPlaceCategory(category: PlaceType | string) {
    console.log('category', category);
    if (typeof category === 'string') {
      this.data.category = category.toString();
      this.data.subTitle = category.toString();
      delete this.data.categoryList;
      delete this.data.category_id;
    } else {
      this.data.categoryList = (category as PlaceType).categoryList;
      this.data.subTitle = (category as PlaceType).title;
      this.data.category_id = (category as PlaceType)._id;
      delete this.data.category;
    }
    delete this.data.isToBeExport;
    delete this.data.choice;
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public check() {
    console.log(this.data.exportType);
    console.log('data.isPrintVersion', this.data.isPrintVersion);
  }

  public sourceFilter() {
    setTimeout(() => {
      if (
        (this.data.isEvent && this.data.eventSource === 'choice') ||
        (!this.data.isEvent && this.data.placeSource === 'choice')
      ) {
        this.data.choice = true;
        delete this.data.isToBeExport;
        delete this.data.categoryList;
      }

      if (
        (this.data.isEvent && this.data.eventSource === 'selected') ||
        (!this.data.isEvent && this.data.placeSource === 'selected')
      ) {
        this.data.isToBeExport = true;
        delete this.data.choice;
        delete this.data.categoryList;
      }
    });
  }

  public confirm(event: ButtonTriggerEvent) {
    if (this.data.isAsync) {
      let oldFunc = event.complete;
      event.complete = () => {
        oldFunc();

        this.dialogRef.close();
      };

      let progressCallback = (progress) => {
        this.progress = progress;
      };

      if (this.data.from) {
        this.data.from.setHours(0);
        this.data.from.setMinutes(0);
        this.data.from.setSeconds(0);
      }
      if (this.data.to) {
        this.data.to.setHours(0);
        this.data.to.setMinutes(59);
        this.data.to.setSeconds(59);

        let date = EventTimeService.addHours(this.data.to, 23);
        this.data.to = new Date(date);
      }

      if (this.data.exportType === 'CSV' && this.data.approvalStatus) {
        switch (this.data.approvalStatus) {
          case 'all':
            this.data.isApproved = undefined;
            break;
          case 'approved':
            this.data.isApproved = true;
            break;
          case 'unapproved':
            this.data.isApproved = false;
            break;
        }
      }
      this.exportPdfStore.expoertPdfCommand.next(this.data);
      this.progress = '0%';
      this.actions.confirm(event, progressCallback);
    } else {
      this.actions.confirm(event);
      this.dialogRef.close();
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/export.pdf.modal/export.pdf.modal.component.ts